const autocompleteModalFilterEquip = {
  maintenance: 'Equipamentos em manutenção',
  valid: 'Equipamentos aptos para uso',
  validWithOpenedActions: 'Equipamentos aptos em adequação',
  inactive: 'Equipamentos inativos',
  invalid: 'Equipamentos não aptos para uso',
  inDelay: 'Serviços em atraso',
  notDone: 'Serviços obrigatórios não realizados',
  hasActionsOpenedOrOverdue: 'Serviços com ações abertas ou vencidas',
  hasNoServices: 'Não possui nenhum serviço',
  mixed: 'Motivos mistos'
};

export default autocompleteModalFilterEquip;
